const brand = sessionStorage.getItem('brand');
export const home = {
  greetingText: 'Përshëndetje, ',
  greetingHand: '👋',
  upgrade: 'Ngritje',
  integrate: 'Integro',
  integrate2: 'Integro',
  chatGPT: 'ChatGPT ',
  forYourBusiness: 'për biznesin tuaj',
  insights: 'Informacione',
  message: 'Mesazhet',
  addon: 'Shtesë: ',
  leads: 'Leada',
  yourBots: 'Botat Tuaja',
  botName: 'Emri i Botit',
  platform: 'Platforma',
  contactOrLeads: 'Kontakte/Leada',
  actions: 'Veprimet',
  edit: 'redakto',
  delete: 'fshij',
  createA: 'Krijo një ',
  whatsappChatbot: 'WhatsApp Chatbot ',
  connect: 'Lidhu',
  getStartedWithUs: 'Filloni me ne 👏',
  howToBuildAGoodChatFlow: ' Si të krijojmë një rrjedhë bisede të mirë',
  howToUseBotPenguinInboxAndItsFeatures: ` Si të përdorim Inbox-in e BotPenguin dhe karakteristikat e tij`,
  botPenguinPricing: ` Çmimet e BotPenguin: Eksplorimi i Planeve dhe Karakteristikave`,
  openHelpDesk: ' Desko Ndihmës të hapur',
  helpAndSupport: 'Ndihmë dhe mbështetje',
  extensiveGuides: 'Udhëzime të zgjeruara për të gjitha pyetjet dhe rrjedhat e punës suaj janë në dispozicion në',
  resourceCentre: 'Qendra e burimeve.',
  checkoutOurAnswers: 'Mund të shihni përgjigjet tona për pyetjet e zakonshme më poshtë.',
  createANewBot: 'Krijo një bot të ri',
  installYourBot: 'Instalo botin tënd',
  plansAndPricing: 'Plane dhe Çmimet',
  searchLanguage: 'Kërko Gjuhën',
  whatsappConversations: 'Bisedat e WhatsApp',
  diveDeeperIntoBotPenguin: 'Ngjituni më thellë në BotPenguin',
  knowWhereWeAreGoing: 'Dini ku po shkojmë, përditësimet e fundit dhe ndihmoni në rregullimin e disa gabimeve.',
  productUpdates: 'Përditësimet e Produktit',
  requestAFeature: 'Kërko një karakteristikë',
  reportABug: 'Raporto një gabim',
  productRoadmap: 'Rruga e Produktit',
  contactsOrLeads: 'Kontakte/Leada',
  english: 'Anglisht',
  hindi: 'Hindi',
  german: 'Gjermanisht',
  french: 'Frëngjisht',
  portuguese: 'Portugezisht',
  spanish: 'Spanjisht',
  italian: 'Italianisht',
  russian: 'Rusisht',
  pleaseSelectYourReason: 'Ju lutem zgjidhni arsyen tuaj',
  cancel: 'Anulo',
  submit: 'Dërgo!',
  giveFeedback: 'Jepni Feedback',
  ratings: 'Vlerësimet',
  reasonBehindYourDecision: 'Arsyeja pas vendimit tuaj',
  shareYourExperience: 'Ndani eksperiencën tuaj',
  reason1: 'arsye1',
  reason2: 'arsye2',
  appTooltip: {
    HOME_INSIGHT: 'Furnizonë perspektivë për të gjitha mesazhet dhe leada të botave tuaja (Të dhënat përditësohen çdo natë)',
    HOME_MESSAGES: 'Mesazhet e konsumuara nga llogaria juaj gjatë këtij cikli faturimi. (Mesazhet nga WhatsApp, Facebook dhe Telegram Bot janë të përjashtuara.)',
    HOME_TOTAL_MESSAGES: 'Totali i mesazheve të konsumuara nga llogaria juaj që nga krijimi i llogarisë (Mesazhet nga WhatsApp, Facebook dhe Telegram Bot janë të përjashtuara.)',
    LEADS: 'Leada të kapura nga botat për llogarinë tuaj gjatë këtij cikli faturimi.',
    TOTAL_LEADS: 'Totali i kontakteve/leadave të kapura nga botat për llogarinë tuaj që nga krijimi i llogarisë (Të dhënat përditësohen çdo natë).',
    YOUR_BOT: 'Përmbledhje e të gjitha botave tuaja dhe përdorimit të tyre gjatë këtij cikli faturimi.',
    NAME: 'Emri i Botit',
    PLATFORM: 'Platforma e Botit',
    MESSAGES: 'Totali i mesazheve të Botit që nga krijimi i llogarisë',
    CONTACTS: 'Totali i kontakteve/leadave të Botit',
    ACTIONS: 'Redakto/Fshij botin',
    EDIT_ICON: 'Redakto botin dhe ciletimet e tij',
    DELETE_ICON: 'Fshij botin',
    TOOL_TIP_CLASSIC_VERSION: `Versioni i vjetër i ${brand} UI`
  },
  modal: {
    deleteBot: 'Fshi Botin!',
    areYouSure: 'A jeni i sigurt që dëshironi të fshini këtë Bot?',
    enquiryForm: 'Formulari i Kërkesës',
    payNow: 'Paguaj Tani!',
    saveAndDelete: 'Ruaj dhe Fshi',
    submit: 'Dërgo',
  },
  noDataFound: {
    bots: 'Botat',
    noBotCreatedYet: 'Asnjë bot nuk është krijuar ende!',
  },
  yourFriendWillMissYou: 'Shoku juaj do ju mungojë',
  rateYourBotCreationExperience: 'Vlerësoni eksperiencën tuaj të krijimit të botit',
  whatMadeYouDeleteYourBot: 'Çfarë ju bë të fshini botin tuaj?',
  iCreatedByMistake: 'E krijova me gabim',
  iWantToCreateAnotherBot: 'Dua të krijoj një bot tjetër',
  couldNotFindFeaturesThatINeeded: 'Nuk mund të gjendja karakteristikat që kisha nevojë',
  uiWasHardToNavigate: 'UI ishte e vështirë për t’u naviguar',
  iDonotWantToTell: 'Nuk dua të them',
  other: 'Tjetër',
  weWillDoOurBestToMakeAutomationFun: 'Do të bëjmë çmos të bëjmë automatizimin argëtues dhe të thjeshtë për të gjithë.',
};
